import WebPageLayout from "../../../../../layouts/WebPageLayout";
import {ScreenProps} from "../../../../../../../utils/screen-props-helper";
import {SystemBuildingsStackParamList} from "../../SystemBuildingsStack";
import {
  useGetBuildingQuery,
  useGetFloorsQuery
} from "../../../../../../../store/services/api/building-api";
import SystemFloorsList from "./components/SystemFloorsList";
import SubManagePageLayout from "../../../../../layouts/SubManagePageLayout";
import {useState} from "react";
import SystemFloorsForm from "./components/SystemFloorsForm";
import {useSetLoading} from "../../../../../../../hooks/useSetLoading";
import {TextInput} from "react-native-paper";
import {View} from "react-native";

export default function SystemFloorsScreen({route}: ScreenProps<SystemBuildingsStackParamList, 'floors'>) {
  const buildingId = route?.params?.buildingId;
  const {data: building, isLoading} = useGetBuildingQuery(buildingId);

  const [filter, setFilter] = useState({ name: "" });
  const {data: floors, refetch, isFetching} = useGetFloorsQuery({
    buildingId,
    pageNumber: 1,
    pageSize: 1000,
    name: filter.name || undefined,
  });

  useSetLoading([isFetching, isLoading]);

  const [selectedFloor, setSelectedFloor] = useState();

  return (
    <WebPageLayout header={{
      previousTab: {title: 'Buildings', routeName: 'list'},
      tabs: [
        {title: building?.name, hidden: !building?.name, disabled: true},
        {title: 'Floors', routeName: 'floors'}
      ]
    }}>
      <SubManagePageLayout
        form={(
          <SystemFloorsForm
            floor={selectedFloor}
            buildingId={buildingId}
            onSubmit={refetch}
            onClearSelection={() => setSelectedFloor(null)}
          />
        )}
        table={(
          <View style={{flex: 1}}>
            <View style={{flexDirection: "row", justifyContent: "flex-end", marginBottom: 12}}>
              <TextInput
                label="Search Floors"
                mode="outlined"
                value={filter.name}
                onChangeText={(text) => {
                  setFilter({...filter, name: text});
                }}
                onSubmitEditing={refetch}
                style={{width: 250}}
              />
            </View>

            <SystemFloorsList
              floors={floors?.list}
              onFloorSelected={setSelectedFloor}
              onFloorDeleted={refetch}
            />
          </View>
        )}
      />
    </WebPageLayout>
  )
}
